<h1 mat-dialog-title>Validation du versement</h1>
<form (ngSubmit)="onSubmit()" [formGroup]="dialogForm" style="margin-top: 20px">
  <mat-dialog-content class="mat__typography">
    <div fxLayout="column" fxLayoutGap="15px">
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(95% - 5px)">
          <mat-label>Indiquer la date de prise en charge</mat-label>
          <input matInput formControlName="incomingDate" [matDatepicker]="datepicker" data-cy="input-dialog-done-incomingDate">
          <mat-hint>JJ/MM/AAAA</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
          <mat-datepicker #datepicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button (click)="onNoClick()" color="primary" data-cy="btn-dialog-done-cancel">Annuler</button>
    <button mat-raised-button
            cdkFocusInitial
            color="accent"
            type="submit"
            [disabled]="!dialogForm.valid" data-cy="btn-dialog-done-send">Envoyer
    </button>
  </div>
</form>
